import { ReadObject, SaveObject } from './storage'

export const SESSION_EXPIRED_NOTICE_KEY = 'MagVenture::session_expired_notice'

// In-flight work must not write sessions after logout, expiry or account change.
export const AREA_SESSION_KEYS = ['authentication', 'mvu_essentials', 'mvu_accelerator']
let sessionRevision = 0
let logoutPending = false
export const invalidateSessionWork = () => ++sessionRevision
export const beginSessionLogout = () => { invalidateSessionWork(); logoutPending = true }
export const captureSessionState = () => ({
  writable: !logoutPending,
  revision: sessionRevision,
  tokens: AREA_SESSION_KEYS.map(key => ReadObject(key)?.jwt || null),
})
export const isSessionStateCurrent = snapshot => snapshot.revision === sessionRevision
  && AREA_SESSION_KEYS.every((key, index) => (ReadObject(key)?.jwt || null) === snapshot.tokens[index])
export const clearIdentitySessionData = () => {
  invalidateSessionWork()
  logoutPending = false
  for (const key of [...AREA_SESSION_KEYS, 'identity_session', 'user', 'lists']) SaveObject(key, {})
  SaveObject('filtered', null)
}

const markSessionExpired = () => {
  try {
    window.sessionStorage.setItem(SESSION_EXPIRED_NOTICE_KEY, 'true')
  } catch (error) {
    // The login redirect still works when browser storage is unavailable.
  }
}

export const clearExpiredSessionData = async sessionKey => {
  invalidateSessionWork();
  [
    [sessionKey, {}],
    ['identity_session', {}],
    ...(ReadObject('identity_session')?.centralUserId ? [
      ['authentication', {}], ['mvu_essentials', {}], ['mvu_accelerator', {}],
    ] : []),
    ['user', {}],
    ['lists', {}],
    ['filtered', null],
  ].forEach(([key, value]) => {
    try {
      SaveObject(key, value)
    } catch (error) {
      // Continue to the login even if one browser storage entry cannot be cleared.
    }
  })

  markSessionExpired()
}

export const consumeSessionExpiredNotice = () => {
  try {
    const shouldNotify = window.sessionStorage.getItem(SESSION_EXPIRED_NOTICE_KEY) === 'true'
    window.sessionStorage.removeItem(SESSION_EXPIRED_NOTICE_KEY)
    return shouldNotify
  } catch (error) {
    return false
  }
}

export const buildSessionExpiredLoginUrl = loginPath => (
  `${loginPath}?reason=session-expired&v=${Date.now()}`
)
